import { Injector, PendingTasks, inject } from '@angular/core';
import { pendingUntilEvent } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';

/**
 * Re-export so call sites can import the operator from one place.
 */
export { pendingUntilEvent };

/**
 * Pipes an Observable through PendingTasks for SSR correctness.
 * Equivalent to AngularFire's keepUnstableUntilFirst.
 *
 * Must be called from an injection context (the operator captures the
 * current Injector via inject()).
 */
export function trackPending<T>(source: Observable<T>): Observable<T> {
  return source.pipe(pendingUntilEvent());
}

/**
 * Marks the app pending until a one-shot Promise settles.
 * Use for getDoc/getDocs/httpsCallable promises consumed during render.
 */
export function trackPendingPromise<T>(p: Promise<T>, injector?: Injector): Promise<T> {
  const tasks = (injector ?? inject(Injector)).get(PendingTasks);
  const removeTask = tasks.add();
  p.finally(removeTask);
  return p;
}
